import { render, staticRenderFns } from "./sourceColumnModal.vue?vue&type=template&id=5fb6e826&scoped=true"
import script from "./sourceColumnModal.vue?vue&type=script&lang=js"
export * from "./sourceColumnModal.vue?vue&type=script&lang=js"
import style0 from "./sourceColumnModal.vue?vue&type=style&index=0&id=5fb6e826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb6e826",
  null
  
)

export default component.exports